import React, { PropsWithChildren } from 'react';
import { Box, makeStyles,} from '@material-ui/core';
import TopBar from './TopBar';



const useStyles = makeStyles({
  
  
  root:{
    overflow:'hidden',
    height: '100%'
  },
  content:{
    overflow:'hidden'
  },
  navbar:{
    overflow:'visible',
  }
  
  
});

export const Root = ({ children }: PropsWithChildren<{}>) => {
  const classes=useStyles()
  return(
  <Box className={classes.root}>
    <Box className={classes.navbar}>
    <TopBar />
    </Box>
    <Box className={classes.content}>
    {children}
    </Box>
  </Box>
)};



{/* <Sidebar>
      <SidebarLogo />
      {location.pathname !== '/' && (<SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
        <SidebarSearchModal />
      </SidebarGroup>)}
      {location.pathname !== '/'  && <SidebarDivider />}
      <SidebarGroup label="Menu" icon={<MenuIcon />}>
        
        
        <SidebarItem icon={HomeIcon} to="/" text="Home"/>
        <SidebarItem icon={CategoryIcon} to="catalog" text="Catalog" />
        // https://gitlab-ucc.tools.aws.vodafone.com/ucc-platform/infrastructure/sandbox-iac-live/-/blob/master/catalog-info.yaml?ref_type=heads<SidebarItem icon={BuildIcon} to="infra-self-service" text="Self-service" /> 
        <SidebarItem icon={ExtensionIcon} to="api-docs" text="APIs" />
        <SidebarItem icon={LibraryBooks} to="docs" text="Docs" />
        <SidebarItem icon={CreateComponentIcon} to="create" text="Create..." />
        
        <SidebarDivider />
        <SidebarScrollWrapper>
          <SidebarItem icon={MapIcon} to="tech-radar" text="Tech Radar" />
          {allowed && <SidebarItem icon={MoneyIcon} to="cost" text="Cost Insights" />}
        </SidebarScrollWrapper>
      </SidebarGroup>
      <SidebarSpace />
      <SidebarDivider />
      <SidebarGroup
        label="Settings"
        icon={<UserSettingsSignInAvatar />}
        to="/settings"
      >
        <SidebarSettings />
      </SidebarGroup>
    </Sidebar> */}